import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Alert } from './Alert';
export var AlertContainer = inject('appStore')(observer(function (props) {
    var generateAlerts = function (alerts) {
        return alerts.map(function (alert, index) { return (React.createElement(Alert, { id: alert.id, key: index, title: alert.title, message: alert.message, type: alert.type, icon: alert.icon, dismissible: alert.dismissible })); });
    };
    return React.createElement(React.Fragment, null, generateAlerts(props.appStore.alerts));
}));
//# sourceMappingURL=AlertContainer.js.map